export enum SocialNetworkInstanceImageType {
  BACKGROUND = 'BACKGROUND',
  COVER = 'COVER',
  LOGO = 'LOGO',
  PROFILE = 'PROFILE',
}
